import React from "react";
import {
  Box,
  IconButton,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip
} from "@mui/material";
import sdImage from "../../assets/dashboard/sd.svg";
import csdImage from "../../assets/dashboard/csd.svg";
import dbImage from "../../assets/dashboard/db.svg";
import threePlusImage from "../../assets/dashboard/3+.svg";
import eolImage from "../../assets/dashboard/eol.svg";
import changesImage from "../../assets/dashboard/changes.svg";
import InfoIcon from "@mui/icons-material/Info";
const EnhancedTableHead = props => {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  const headCellsBeforeAction = [
    {
      id: "FirstName",
      numeric: false,
      disablePadding: true,
      label: "Full Name"
    },
    {
      id: "TrainingStartedOn",
      numeric: false,
      disablePadding: false,
      label: "First T.D"
    },
    {
      id: "LastSessionDoneAt",
      numeric: false,
      disablePadding: false,
      label: "Latest T.D"
    },
    {
      id: "nextTestDate",
      numeric: false,
      disablePadding: false,
      label: "Next Test"
    },
    {
      id: "CalibScore",
      numeric: false,
      disablePadding: false,
      label: "Cal Score"
    },
    {
      id: "StandardDeviation",
      numeric: false,
      disablePadding: false,
      label: "Training SD"
    },
    {
      id: "CalibrationStandardDeviation",
      numeric: false,
      disablePadding: false,
      label: "Cal SD"
    }
  ];

  const headCellsAfterAction = [
    { id: "Stared", numeric: false, disablePadding: false, label: "Starred" },
    {
      id: "schoolKid",
      numeric: false,
      disablePadding: false,
      label: "School Kid"
    },
    {
      id: "statistics",
      numeric: false,
      disablePadding: false,
      label: "Statistics"
    }
  ];
  return (
    <TableHead>
      <TableRow>
        {headCellsBeforeAction.map(headCell => (
          <TableCell
            key={headCell.id}
            align="center"
            style={{
              borderRight: "1px solid #d3d3d3",
              fontSize: "12px",
              fontWeight: "600"
            }}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "desc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" style={{ display: "none" }}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell
          align="center"
          style={{
            borderRight: "1px solid #d3d3d3",
            fontSize: "12px",
            fontWeight: "600"
          }}
        >
          Action
          <Tooltip
            title={
              <React.Fragment>
                <img
                  src={sdImage}
                  style={{ width: "30px", height: "30px" }}
                  alt=""
                />{" "}
                - Training Standard Deviation
                <br />
                <img
                  src={csdImage}
                  style={{ width: "30px", height: "30px" }}
                  alt=""
                />{" "}
                - Calibration Standard Deviation
                <br />
                <img
                  src={dbImage}
                  style={{ width: "30px", height: "30px" }}
                  alt=""
                />{" "}
                - Read from backend
                <br />
                <img
                  src={threePlusImage}
                  style={{ width: "30px", height: "30px" }}
                  alt=""
                />{" "}
                - Didn't train from 3 or more days
                <br />
                <img
                  src={eolImage}
                  style={{ width: "30px", height: "30px" }}
                  alt=""
                />{" "}
                - End of lifetime
                <br />
                <img
                  src={changesImage}
                  style={{ width: "30px", height: "30px" }}
                  alt=""
                />{" "}
                - Changes in User DB
                <br />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-left"
                  }}
                >
                  <span className="actionIconText">1</span>
                  <span style={{ display: "flex", justifyContent: "flex-end" }}>
                    {" "}
                    - Latest vergence test number
                  </span>
                </div>{" "}
              </React.Fragment>
            }
            placement="right"
          >
            <IconButton size="small">
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
        {headCellsAfterAction.map(headCell => (
          <TableCell
            key={headCell.id}
            align="center"
            style={{
              borderRight: "1px solid #d3d3d3",
              fontSize: "12px",
              fontWeight: "600"
            }}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
